import { Expose } from "class-transformer";

export class UpdateProjectHasTaskTypeDto {
  @Expose()
  projectId: string;

  @Expose()
  taskTypeId: string;
}
